/* eslint-disable @typescript-eslint/no-explicit-any */
const merchandisingLuxuryBrand = ['RC', 'XR', 'LC', 'WH', 'EB', 'JW', 'RZ'];

export const getUpdateModelJson = (
  modelJsonData: any,
  preProcessorResponse: {
    state?: '' | undefined;
    mac?: '' | undefined;
    cna?: '' | undefined;
    userSegment?: '' | undefined;
    brandCode?: '' | undefined;
    marsha?: '' | undefined;
    pageComponentOrder?: Record<any, any>;
    userState?: 'basic' | 'elite';
  }
) => {
  const items = modelJsonData?.[':items'];
  const itemsOrder =
    preProcessorResponse &&
    preProcessorResponse?.pageComponentOrder &&
    preProcessorResponse?.pageComponentOrder?.itemsOrder &&
    preProcessorResponse?.pageComponentOrder?.itemsOrder?.length
      ? preProcessorResponse?.pageComponentOrder?.itemsOrder
      : modelJsonData?.[':itemsOrder'];

  const columnClassNames = modelJsonData?.columnClassNames;

  let updatedItems = {};
  const updatedItemsOrder: string[] = [];
  let updatedColumnClassNames = {};
  const merchandisingContectID = 'merchandising';
  const { state, mac, cna, userSegment, brandCode, marsha, userState } = preProcessorResponse || {};

  itemsOrder?.forEach((itemKey: string) => {
    if (items?.[itemKey]?.[':type'] === 'mi-aem-ppv5-spa/components/content/brandedcontainer') {
      const { brandConfigCards = [], doHide = false, selectedStates = [] } = items?.[itemKey] ?? {};
      let brandConfigCardMatch = false;
      const updatedState = state?.replace('_', '-');
      const isCNA = cna;
      const isMAC = mac;
      const updatedUserSegment = userSegment?.toLowerCase()?.replaceAll(' ', '');

      let showContainer = true;
      if (brandConfigCards && brandConfigCards?.length) {
        for (let i = 0; i < brandConfigCards?.length; i++) {
          const brandConfigCard = { ...brandConfigCards[i] };
          const stateSelector = brandConfigCard?.stateSelector?.toLowerCase();

          const brandStateMatch =
            stateSelector === updatedState ||
            (isCNA && stateSelector === 'cna') ||
            (isMAC && stateSelector === 'mac') ||
            (updatedUserSegment === 'loggedin' && stateSelector === 'loggedin') ||
            (updatedUserSegment === 'notloggedin' && stateSelector === 'nonloggedin') ||
            (userState === 'basic' && selectedStates?.includes('userstate-basic')) ||
            (userState === 'elite' && selectedStates?.includes('userstate-elite'));

          const selectorBrandCodes = brandConfigCard?.selectorBrandCodes?.toLowerCase()?.split(',');
          const brandCodeMatch = selectorBrandCodes?.includes(brandCode?.toLowerCase());

          const brandMarshaCodes = brandConfigCard?.brandMarshaCodes?.split(',');
          const marshaCodeMatch = brandMarshaCodes?.includes(marsha?.toLowerCase());

          if ((brandStateMatch && marshaCodeMatch) || (brandStateMatch && brandCodeMatch)) {
            if (brandConfigCard?.brandSelectVisibilityMarsha?.toLowerCase() === 'hide') {
              showContainer = false;
            } else {
              showContainer = true;
            }
            brandConfigCardMatch = true;
            break;
          }
        }
      }

      if (!brandConfigCardMatch) {
        const stateMatch =
          selectedStates?.includes(updatedState) ||
          (isCNA && selectedStates?.includes('cna')) ||
          (isMAC && selectedStates?.includes('mac')) ||
          (updatedUserSegment === 'loggedin' && selectedStates?.includes('loggedin')) ||
          (updatedUserSegment === 'notloggedin' && selectedStates?.includes('nonloggedin')) ||
          (userState === 'basic' && selectedStates?.includes('userstate-basic')) ||
          (userState === 'elite' && selectedStates?.includes('userstate-elite'));

        if (stateMatch) {
          if (doHide) {
            showContainer = false;
          } else {
            showContainer = true;
          }
        }
      }

      if (items?.[itemKey]?.contentID === merchandisingContectID) {
        if (brandCode && merchandisingLuxuryBrand.includes(brandCode)) {
          showContainer = false;
        }
      }

      if (showContainer) {
        updatedItems = {
          ...updatedItems,
          [itemKey]: items?.[itemKey],
        };
        updatedColumnClassNames = {
          ...updatedColumnClassNames,
          [itemKey]: columnClassNames?.[itemKey],
        };
        updatedItemsOrder.push(itemKey);
      }
    } else {
      updatedItems = {
        ...updatedItems,
        [itemKey]: items?.[itemKey],
      };
      updatedColumnClassNames = {
        ...updatedColumnClassNames,
        [itemKey]: columnClassNames?.[itemKey],
      };
      updatedItemsOrder.push(itemKey);
    }
  });

  const updatedModelJson = {
    ...modelJsonData,
    [':items']: {
      ...updatedItems,
    },
    [':itemsOrder']: [...updatedItemsOrder],
    columnClassNames: {
      ...updatedColumnClassNames,
    },
  };
  return updatedModelJson;
};

export const submitDynamicForm = (data: any, postEndpoint: string): void => {
  const form = document.createElement('form');
  const submitFormEndpoint = postEndpoint.indexOf('://') === -1 ? `https://${postEndpoint}` : postEndpoint;
  let parsedEndpoint: URL;
  try {
    parsedEndpoint = new URL(submitFormEndpoint);
  } catch {
    return;
  }
  if (parsedEndpoint.protocol !== 'https:' && parsedEndpoint.protocol !== 'http:') {
    return;
  }
  form.setAttribute('method', 'POST');
  form.setAttribute('action', parsedEndpoint.href);
  form.setAttribute('style', 'display: none');

  for (const property in data) {
    if (data[property] !== null) {
      const input = document.createElement('input');
      input.type = 'text';
      input.id = property;
      input.name = property;
      input.value = data[property];
      form.appendChild(input);
    }
  }

  // add the form inside the body
  document.getElementsByTagName('body')[0].appendChild(form); //pure javascript
  form.submit();
};

export const decodeLSPCookieInfo = (ppv5NextURLData: string) => {
  const decodedText = window.atob(ppv5NextURLData);
  const textDecoderInstance = new TextDecoder('utf-8');
  const cookieDecoded = textDecoderInstance.decode(new Uint8Array([...decodedText].map(char => char.charCodeAt(0))));
  return JSON.parse(cookieDecoded);
};
